module.exports = __webpack_public_path__ + "static/img/apple-store-badge-pt-BR.3cfd02d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple-store-badge-pt-BR.png
// module id = to8B
// module chunks = 1